module.exports = __webpack_public_path__ + "static/media/banner-2.1626baa0.png";